export const objectToQueryParams = (obj) => {
  return Object.keys(obj)
    .map((key) => `${key}=${encodeURI(obj[key])}`)
    .join("&");
};
